import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Select, Store } from '@ngxs/store';
import { CommonService, ContextDocuments, Document, DocumentStateModel, GetDocuments, NetworkMember, DocumentContext, DeleteDocumentContext } from 'huddyapi';

import {  Subscription } from 'rxjs';
import { ConfirmationDialog } from '../../components/confirmation-dialog/confirmation-dialog.component';
import { EditDocumentDialog } from './edit-document-dialog.component';

@Component({
  selector: 'documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit {

  documents : Document[] = [];
  @Input() contextId : number;
  @Input() contextType : string;
  @Input() providerId : number;
  @Select(state => state.documentState) documentState$;
  documentSubscription : Subscription;
  @Input() mode : string = 'page';
  providerLibrary : Document[] = [];

  constructor(
    private store : Store,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.  documentSubscription  = this.documentState$.subscribe((documentState: DocumentStateModel) => {
      console.log('received documentState', documentState);
      if (documentState && documentState.contextDocuments) {
         let idx :number = documentState.contextDocuments.findIndex(cd => cd.matches(this.contextId, this.contextType));
         if (idx > -1) {
          this.documents = [].concat(documentState.contextDocuments[idx].documents);
         }
         if (this.providerId) {
          let filtered : ContextDocuments[] = documentState.contextDocuments.filter(cd => cd.contextType ===  'library');
          this.providerLibrary = [];
          for (let cd of filtered) {
            this.providerLibrary = this.providerLibrary.concat(cd.documents);
          }
        }
        if (this.documents)
          console.log(this.documents, this.documents.map(d => d.name).join(','));   
      }
      
    });

    this.store.dispatch(new GetDocuments(this.contextType, this.contextId, undefined, undefined, undefined));
    if (this.providerId) {
      this.store.dispatch(new GetDocuments(undefined,  undefined, this.providerId, CommonService.currentUserToView, undefined));
    }

  }

  getColorFromName(name : string) : string {
    let ret : string = '#DAC7FD';
    if (name) {
      ret = NetworkMember.getColorForName(name);
      if (ret === 'avatarColor0') {
        ret = '#DAC7FD';
      } else if (ret === 'avatarColor1') {
        ret = '#F06D82';
      } else if (ret === 'avatarColor2') {
        ret = '#75C5EC';
      } else if (ret === 'avatarColor3') {
        ret = '#A7C2EF';
      }
    }
    return ret;
  }

  
  onEdit(data : any) {
    console.log(data);
    if (data === null) {
      let libraryFiltered : Document[] = [];
      for (let doc of this.providerLibrary) {
        let idx : number = this.documents.findIndex(d => d.id === doc.id);
        if (idx === -1) {
          libraryFiltered.push(doc);
        }
      }
      //add
      data = {
        library: libraryFiltered,
        id: -1,
        contexts : [new DocumentContext({
          contextId : this.contextId,
          contextType : this.contextType
      })]
      }
    } 
    this.dialog.open(EditDocumentDialog, {
      width: '600px',
      height: '525px',
      data: data
    });
  }
  
  onDelete(document : Document) {
    let documentContext : DocumentContext = document.contexts[0];
    this.dialog.open(ConfirmationDialog, {
      width: '636px',
      data: {
        minWidth: '127px',
        title: 'Delete ' + document.name,
        body: 'Are you sure you want to delete ' + document.name + '?',
        buttons: [
          {
            text: 'Cancel',
            class: 'secondary',
            handler: (): boolean => {
              return false;
            }
          },
          {
            text: 'Confirm',
            class: '',
            handler: () => {
               this.store.dispatch(new DeleteDocumentContext(documentContext)).subscribe(r => {
                 console.log('deleted', documentContext);
               });
            }
          }
        ]
      }
    });
  }
}